 <template>
    <div>
        <exportComponents ref="exportComponents" :exportCode="type"></exportComponents>
    </div>
</template>
<script>
import exportComponents from '@/components/AEO/exportComponents.vue'
export default {
    name: 'exportDeclare',
    components:{
        exportComponents
    },
    watch: { 
        '$route'(to, from) {
            if (to.path === '/exportDeclare') {
                 // 路由变化时执行逻辑
                if (!this.eventBusDataReceived) { // 标志位，避免重复触发
                    this.$nextTick(() => {
                        if (this.$refs.exportComponents) {
                            const { id = '', entryNo = '', seqNo = '' } = to.query;
                            this.$refs.exportComponents.getdeclareDetails(id, false, entryNo, seqNo);
                        }
                    });
                }
                this.eventBusDataReceived = false; // 重置标志位
             }

        }
    },
    data() {
        return {
            type:'E',
            eventBusDataReceived:false,
        }
    },
    created() {
        this.$eventBus.$on('data-exportID', (data) => {
            this.eventBusDataReceived = true; // 标记已接收 EventBus 数据
            this.copyExportID(data);
        });
    },
    mounted() {
        this.$refs.exportComponents.getdeclareDetails(this.$route.query.id,false,this.$route.query.entryNo,this.$route.query.seqNo)
    },
    methods: {
        copyExportID(data){
            this.$refs.exportComponents.getdeclareDetails(data.id,true,'','')
        }
    },
    beforeDestroy() {
        // 移除监听，避免内存泄漏！
        this.$eventBus.$off('data-exportID', this.copyExportID);
    },
}
</script>
<style lang="css" scoped>

</style>